import { v4 } from 'uuid';

export default function uuidv4(): string {
  return v4();
}
